const language = {
	spanish: {
		header_title: "Botes",
		botes_yellow_title: "BOTES",
		botes_bold_title:
			"Sin importar el tipo de embarcación Foresight GPS le permite instalar e integrar distintos tipos de sensores en estos vehículos para proteger la inversión y maximizar el rendimiento de estas.",
		botes_bold_text: "Automatización de alertas de mantenimiento",
		botes_text: [
			"Las averías inesperadas pueden provocar el incumplimiento de los plazos, la pérdida de ingresos y la insatisfacción de los clientes.El rastreo vía GPS y la telemática de alta calidad en equipos de construcción puede mantenerlo actualizado sobre las necesidades de mantenimiento y ayudarle a programar el servicio proactivo de manera",
		],
		beneficios_yellow_title: "BENEFICIOS",
		beneficios_list: [
			{
				text: "Conozca la ubicación de sus embarcaciones en tiempo real sobre mapas digitalizados desde cualquier dispositivo.",
				column: "1",
			},
			{
				text: "Prevenga robos.",
				column: "1",
			},
			{
				text: "Controle uso de la embarcación para prevenir malos usos.",
				column: "1",
			},
			{
				text: "Reciba alertas de exceso de velocidad en embarcaciones.",
				column: "1",
			},
			{
				text: "Administre el uso de combustible remotamente.",
				column: "1",
			},
			{
				text: "Obtenga un inventario y ubicación de la flota en un instante.",
				column: "2",
			},
			{
				text: "Reciba alertas de seguridad por rebasar límites a través de geocercas digitales.",
				column: "2",
			},
			{
				text: "Rastrear el paradero de la embarcación en caso de robo.",
				column: "2",
			},
			{
				text: "Soporte 24/7.",
				column: "2",
			},
		],
		caracteristicas_yellow_title: "CARACTERÍSTICAS",
		caracteristicas_bold_title:
			"Contamos con la mejor innovación tecnológica para un rastreo óptimo de sus activos móviles:",
		caracteristicas_list: [
			"Generación de variedad de alertas según la necesidad de la operación.",
			"Integración de gran catálogo de dispositivos GPS.",
			"Gestión de activos acuáticos desde aplicación web o móvil.",
			"Configuración de alertas de mantenimiento preventivo por distancia u horas de uso.",
			"Configuración de alertas de proximidad entre embarcaciones",
		],
		dashboard_yellow_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Fue diseñado para visualizar los indicadores clave de rendimiento de forma rápida y eficiente, facilitando la toma de decisiones ante grandes volúmenes de datos.",
		dashboard_bold_text:
			"Con distintos conjuntos de tableros puedes ver la velocidad media, máxima y promedio de la flota, el kilometraje por unidad, el consumo de combustible promedio individual o por flota, las horas del motor encendido y el tiempo en los viajes, y más.",
		dashboard_text: [
			"Además se pueden incluir nuevos sets de datos y personalizar los Dashboard a las necesidad específicas de cada operación.",
		],
		dashboard_list: [
			"Procesamiento de data.",
			"Presentación gráfica de resultados.",
			"Comparativo de resultados entre diferentes vehículos.",
			"Identificador de variables fuera de rango.",
			"Interfaz gráfica amigable y fácil de leer.",
			"Control de múltiples variables de manera simultánea.",
			"Información discriminada en piloto/embarcación y flota.",
		],
	},
	english: {
		header_title: "Boats",
		botes_yellow_title: "BOATS",
		botes_bold_title:
			"ForesightGPS allows you to install and integrate different types of sensors onto these vehicles regardless of their type, to protect your investment and maximize your revenue.",
		botes_bold_text: "Automation of maintenance alerts",
		botes_text: [
			"Unexpected breakdowns can lead to missed deadlines, lost revenue and customer dissatisfaction. GPS tracking and high quality telematics on construction equipment can keep you up to date on maintenance needs and help you schedule proactive service in a timely manner.",
		],
		beneficios_yellow_title: "BENEFITS",
		beneficios_list: [
			{
				text: "Know the location of your boats in real time on a digital map from any device.",
				column: "1",
			},
			{
				text: "Theft prevention.",
				column: "1",
			},
			{
				text: "Control boat use and prevent misuse.",
				column: "1",
			},
			{
				text: "Receive alerts on speeding boats.",
				column: "1",
			},
			{
				text: "Manage fuel usage remotely.",
				column: "1",
			},
			{
				text: "Get inventory and location of the fleet in an instant.",
				column: "2",
			},
			{
				text: "Receive safety alert for exiting digital geofences.",
				column: "2",
			},
			{
				text: "Track the whereabouts of a stolen boat.",
				column: "2",
			},
			{
				text: "24/7 support.",
				column: "2",
			},
		],
		caracteristicas_yellow_title: "FEATURES",
		caracteristicas_bold_title:
			"We have the best technological innovations for the optimal tracking of your mobile assets:",
		caracteristicas_list: [
			"Generation of a variety of alerts according to the needs of the operation.",
			"Integration of a large catalog of GPS devices.",
			"Management of aquatic assets on the mobile app or web.",
			"Configuration of preventive maintenance alerts by distance or hours of use.",
			"Configuration of proximity alerts between vessels",
		],
		dashboard_yellow_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Designed to display key performance indicators quickly and efficiently, facilitating decision making when faced with large volumes of data.",
		dashboard_bold_text:
			"With different sets of dashboards allow you to view fleet average, maximum and average speed, milage per unit, average of fuel consumption of the fleet or individual, engine running hours, and more.",
		dashboard_text: [
			"Also can be customized to the specific needs of operation, including new data sets.",
		],
		dashboard_list: [
			"Data processing.",
			"Graphic presentation of results.",
			"Comparison of results between different vehicles.",
			"Out of range variable identifier.",
			"Friendly and easy-to-read graphical interface.",
			"Simultaneous control of multiple variables.",
			"Information on pilot, boat or fleet.",
		],
	},
};

export default language;